(function () {
	'use strict';

	var productLoader = require('./_productLoader');
	var tabFilters = require('./_tabFilters');
	var scrollArrows = require('./_scrollArrows');
	var _Lazyload = require('./_Lazyload.js');
	var observeCarousel = require('./videoCarousel/index');
	var hotspots = require('./hotspots/index');

	function initCtaDropdown() {
		var wrapper = document.getElementById('hero-collage__cta-dropdown');
		if (!wrapper) return;

		var trigger = wrapper.querySelector('.hero-collage__cta-dropdown-trigger');
		var menu = wrapper.querySelector('.hero-collage__cta-dropdown-menu');
		if (!trigger || !menu) return;

		function openMenu() {
			menu.classList.add('is-open');
			trigger.setAttribute('aria-expanded', 'true');
		}

		function closeMenu() {
			menu.classList.remove('is-open');
			trigger.setAttribute('aria-expanded', 'false');
		}

		trigger.addEventListener('click', function(e) {
			e.stopPropagation();
			var isOpen = menu.classList.contains('is-open');
			if (isOpen) {
				closeMenu();
			} else {
				openMenu();
			}
		});

		// Close when clicking outside
		document.addEventListener('click', function(e) {
			if (!wrapper.contains(e.target)) {
				closeMenu();
			}
		});

		// Keyboard: Escape closes and returns focus to trigger; Arrow Down opens and focuses first item
		trigger.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				closeMenu();
				trigger.focus();
			} else if (e.key === 'ArrowDown') {
				e.preventDefault();
				openMenu();
				var first = menu.querySelector('.hero-collage__cta-dropdown-item');
				if (first) first.focus();
			}
		});

		// Keyboard navigation within the open menu
		menu.addEventListener('keydown', function(e) {
			var focusableItems = Array.prototype.slice.call(menu.querySelectorAll('.hero-collage__cta-dropdown-item'));
			var idx = focusableItems.indexOf(document.activeElement);
			if (e.key === 'Escape') {
				e.preventDefault();
				closeMenu();
				trigger.focus();
			} else if (e.key === 'ArrowDown') {
				e.preventDefault();
				if (idx < focusableItems.length - 1) focusableItems[idx + 1].focus();
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				if (idx > 0) {
					focusableItems[idx - 1].focus();
				} else {
					closeMenu();
					trigger.focus();
				}
			} else if (e.key === 'Tab') {
				closeMenu();
			}
		});

		// Close when clicking a menu item; also handle app target override
		var items = menu.querySelectorAll('.hero-collage__cta-dropdown-item');
		for (var i = 0; i < items.length; i++) {
			if (window.isSiteInApp) {
				items[i].setAttribute('target', '_self');
			}
			items[i].addEventListener('click', function() {
				closeMenu();
			});
		}
	}

	function init() {
		console.log('page.js init() called');
		
		// Initialize CTA dropdown navigation
		initCtaDropdown();

		// Initialize product loader first (exposes window.INTPRODUCTPOOL)
		if (productLoader && typeof productLoader.start === 'function') {
			productLoader.start();
		}

		if (tabFilters && typeof tabFilters.initTabFilters === 'function') {
			tabFilters.initTabFilters();
		}

		if (scrollArrows && typeof scrollArrows.initHorizontalScrollArrows === 'function') {
			scrollArrows.initHorizontalScrollArrows({
				selector: '.productgrid-products',
				leftSrc: '{{ASSETS_DIR}}/images/left-arrow.png',
				rightSrc: '{{ASSETS_DIR}}/images/right-arrow.png'
			});
		}
		
		if (_Lazyload && typeof LazyLoad.init === 'function') {
			LazyLoad.init();
		}

		if (observeCarousel && typeof observeCarousel === 'function') {
			observeCarousel({carouselId: 'videos'});
		}
		if (hotspots && typeof hotspots.init === 'function') {
			hotspots.init();
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();